import { create } from 'zustand';

import { isTargetEntry } from '../utils';

import type {
  EntryIdentifier,
  ScrollObserverEntry,
  ScrollObserverStoreAction,
  ScrollObserverStoreState,
} from '../provider/ScrollObserverProvider';

export const useScrollObserverStore = create<ScrollObserverStoreState & ScrollObserverStoreAction>(
  (set, get) => ({
    entries: [],
    addEntry: (targetEntry: ScrollObserverEntry) => {
      const isExistEntry = !!get().entries.find(entry => isTargetEntry(entry, targetEntry));
      if (isExistEntry) {
        /**
         * NOTE. 신규로 추가할 targetEntry와 같은 entryId, rootId를 갖는 경우 기존 entry를 대체한다.
         * 단, 개발자가 의도한 케이스가 아닐 것이므로 develement모드에선 error를 발생시킨다.
         */
        get().updateEntry(targetEntry);
        if (process.env.NODE_ENV === 'development') {
          throw new Error(
            `You are trying to add an entry that already exists. (${JSON.stringify({ rootId: targetEntry.rootId, entryId: targetEntry.entryId })})`,
          );
        }
      } else {
        set(prev => {
          const nextEntries = [...prev.entries, targetEntry];
          return { ...prev, entries: nextEntries };
        });
      }
    },
    removeEntry: (targetEntryIdentifier: EntryIdentifier) => {
      set(prev => {
        const nextEntries = prev.entries.filter(
          entry => !isTargetEntry(entry, targetEntryIdentifier),
        );
        return { ...prev, entries: nextEntries };
      });
    },
    getEntryById: (targetEntryIdentifier: EntryIdentifier) => {
      return get().entries.find(entry => isTargetEntry(entry, targetEntryIdentifier));
    },
    updateEntry: (targetEntry: ScrollObserverEntry) => {
      set(prev => {
        const nexEntries = prev.entries.map(entry =>
          isTargetEntry(entry, targetEntry) ? targetEntry : entry,
        );
        return {
          ...prev,
          entries: nexEntries,
        };
      });
    },
  }),
);

export type ScrollObserverState = {
  entries: ScrollObserverEntry[];
};
